export const SURVEY_OPTIONS = {
  showCreatorThemeSettings: false,
  showLogicTab: true,
  isAutoSave: false,
  syncSaveButtons: true,
  showTranslationTab: false,
  showJSONEditorTab: false,
  showThemeTab: true,
  logoPosition: "right",
  questionTypes: ["image", "html", "consent", "checkbox"],
  clearInvisibleValues: "none",
  pageEditMode: "single",
};

export const DEFAULT_JSON = {
  captcha: true,
  logoPosition: "right",
  clearInvisibleValues: "none",
};
